/* GW Product Grid + Video fix */
(function(){
  'use strict';

  /* ---- Clickable card handler ---- */
  if(!window._gwCardClickInitialized){
    window._gwCardClickInitialized=true;
    document.addEventListener('click',function(e){
      var t=e.target;
      var card=t.closest('.gw-clickable-card');
      if(!card)return;
      if(t.closest('a,button,input,select,label,[onclick]'))return;
      if(t.classList.contains('action-plus')||t.classList.contains('compare')||t.classList.contains('wishlist-btn'))return;
      var href=card.getAttribute('data-href');
      if(href)window.location.href=href;
    });
  }

  /* ---- Add to cart from grid ---- */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.btn-add-cart[data-variant-id]');
    if(!btn)return;
    e.preventDefault();
    var vid=btn.getAttribute('data-variant-id');
    if(!vid)return;
    var orig=btn.textContent;
    btn.textContent='Adding...';
    btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
    .then(function(){btn.textContent='Added!';btn.style.background='#059669';setTimeout(function(){btn.textContent=orig;btn.style.background='';btn.disabled=false;document.dispatchEvent(new CustomEvent('cart:refresh'));},2000);})
    .catch(function(){btn.textContent=orig;btn.disabled=false;});
  });

  /* ---- Block Fancybox from hijacking video/external-video clicks ---- */
  /*
   * Fancybox 3 listens for clicks on [data-fancybox] elements anywhere in the DOM.
   * Clicks on video controls bubble up and Fancybox intercepts them.
   * Fix: stop propagation at the video container level BEFORE Fancybox sees it.
   */
  function blockFancyboxOnVideos(){
    /* Native video elements */
    document.querySelectorAll('.gw-native-video, .gw-product-video, .gw-external-video').forEach(function(el){
      if(el._gwVideoFixed) return;
      el._gwVideoFixed = true;
      el.addEventListener('click', function(e){ e.stopPropagation(); }, true);
      /* Also block mousedown/touchstart so fancybox mousedown handler doesn't fire */
      el.addEventListener('mousedown', function(e){ e.stopPropagation(); }, true);
      el.addEventListener('touchstart', function(e){ e.stopPropagation(); }, true);
    });

    /* Also patch Fancybox itself if loaded: exclude data-fancybox-ignore elements */
    if(window.jQuery && window.jQuery.fancybox){
      /* Override Fancybox click trigger to skip data-fancybox-ignore containers */
      var origOpen = window.jQuery.fancybox.open;
      window.jQuery.fancybox.open = function(items, opts, index){
        if(items && items[0] && items[0].opts && items[0].opts.$orig){
          var orig = items[0].opts.$orig[0];
          if(orig && orig.closest('[data-fancybox-ignore]')) return;
        }
        return origOpen.apply(this, arguments);
      };
    }
  }

  /* ---- Video in Slick carousel fix ---- */
  function initProductVideoFix(){
    var slider = document.querySelector('.product-large-slider');
    if(!slider || slider._gwVideoInit) return;
    slider._gwVideoInit = true;

    /* Pause all videos on slide change */
    $(slider).on('beforeChange', function(){
      slider.querySelectorAll('video').forEach(function(v){ v.pause(); });
    });

    /* Fix cloned video sources after Slick init */
    function fixClonedVideos(){
      var originals = slider.querySelectorAll('.slick-slide:not(.slick-cloned) video.gw-product-video');
      var clones = slider.querySelectorAll('.slick-cloned video.gw-product-video');
      originals.forEach(function(orig, i){
        var clone = clones[i];
        if(!clone) return;
        while(clone.firstChild) clone.removeChild(clone.firstChild);
        orig.querySelectorAll('source').forEach(function(src){
          var ns = document.createElement('source');
          ns.src = src.src;
          ns.type = src.type;
          clone.appendChild(ns);
        });
        clone.load();
        /* Block fancybox on clones too */
        clone.closest('.gw-native-video') && (clone.closest('.gw-native-video')._gwVideoFixed = false);
      });
      /* Re-apply fancybox block after clones are fixed */
      blockFancyboxOnVideos();
    }

    $(slider).on('init', fixClonedVideos);
    if($(slider).hasClass('slick-initialized')) fixClonedVideos();
    setTimeout(fixClonedVideos, 800);
    setTimeout(fixClonedVideos, 2000);
  }

  function waitAndInit(){
    if(typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined'){
      initProductVideoFix();
      blockFancyboxOnVideos();
    } else {
      setTimeout(waitAndInit, 300);
    }
  }

  /* Run on DOM ready */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

  /* Theme lazy-load event */
  document.addEventListener('w3-DOMContentLoaded', waitAndInit);
  window.addEventListener('load', function(){ setTimeout(initProductVideoFix, 500); setTimeout(blockFancyboxOnVideos, 500); });

})();
